import React from 'react'
import styles from './partner.module.css'

function Partner({partnerData,text,backgroundColor}) {
  return (
    <div className={styles.trustedPartner} style={{backgroundColor:backgroundColor}}>
        <p className={styles.partnerText}>{text}</p>
        <div className={styles.partnerImages}>
          {partnerData && partnerData.map((data,index) => {
            return(
              <img src={data.src} className={data.text==="PwC" ? styles.image2 : styles.image}alt="zinc"></img>
            )
          })}
        </div>
    </div>
  )
}

export default Partner